module.exports = __webpack_public_path__ + "img/atualizar.efc71b09.svg";